<template>
  <div class="menu">
    <button
      class="menu-item"
      type="button"
      v-if="hasAddBreak"
      v-on:click="onClick('add-break', day)"
    >Добавить перерыв</button>
    <button
      v-if="hasChangeWorkPeriod"
      class="menu-item"
      type="button"
      v-on:click="changeWorkDayClick"
    >Изменить часы работы</button>
    <button
      class="menu-item"
      v-if="hasSetDayOff"
      type="button"
      v-on:click="onClick('set-day-off', day)"
    >Отменить рабочий день</button>
    <button
      class="menu-item"
      type="button"
      v-if="hasViewEmployee"
      v-on:click="onClick('open-profile')"
    >Профиль сотрудника</button>
  </div>
</template>

<script>
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';
import notifierMixin from '@/mixins/notifierMixin';

export default {
  computed: {
    /**
     * @description Может добавлять перерывы.
     * @type {boolean}
     */
    hasAddBreak() {
      return this.actions.includes('breaks');
    },
    /**
     * @description Может просматривать профиль сотрудника.
     * @type {boolean}
     */
    hasViewEmployee() {
      return this.actions.includes('view-employee-profile');
    },
    /**
     * @description Может установить день выходным.
     * @type {boolean}
     */
    hasSetDayOff() {
      return this.actions.includes('change-work-schedule');
    },
    /**
     * @description Может изменять часы работы.
     * @type {boolean}
     */
    hasChangeWorkPeriod() {
      return this.actions.includes('change-work-schedule');
    },
  },
  mixins: [builtInPopoverMixin, notifierMixin],
  name: 'MenuEmployeeAction',
  methods: {
    onClick(command, ...args) {
      this.closePopover();
      this.$emit(command, ...args);
    },
    changeWorkDayClick(e) {
      const coords = e.target.getBoundingClientRect();
      this.onClick(
        'change-work-time',
        this.employeeId,
        coords.x,
        coords.y,
        this.day,
      );
    },
  },
  props: {
    /**
     * @description Допустимые действия.
     * @type {string[]}
     */
    actions: { required: true, type: Array },
    /**
     * @description Идентификатор сотрудника.
     * @type {number}
     */
    employeeId: { required: true, type: Number },
    /**
     * @description Дата в формате ISO.
     * @type {string}
     */
    day: { required: true, type: String },
  },
};
</script>

<style lang="scss">
.menu {
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  gap: 5px;
  &-item {
    padding: 5px;
    text-align: left;
    transition: .1s color;
    &:hover {
      color: var(--action-color);
    }
  }
}
</style>
